import { render, staticRenderFns } from "./ProjectNews.vue?vue&type=template&id=b38c049c&scoped=true&"
import script from "./projectnews.js?vue&type=script&lang=js&"
export * from "./projectnews.js?vue&type=script&lang=js&"
import style0 from "./ProjectNews.vue?vue&type=style&index=0&id=b38c049c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38c049c",
  null
  
)

export default component.exports